import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonImg,
  IonRow,
  IonText,
} from "@ionic/react";
import "./EveryYouNeed.css";
 
function EverythingYouNeed({ id }: { id?: string }) {
  return (
    <IonRow className="eyn ion-justify-content-center white-cards" id={id}>
      <IonCol className="eyn-col">
        <IonRow>
          <IonText className="title">Everything You Need</IonText>
        </IonRow>
        <IonRow className="card-row ion-justify-content-around">
          <IonCol sizeMd="4" sizeXs="12">
            <IonCard className="show-card">
              <IonRow className="ion-justify-content-center">
                <IonImg src="shield-check.svg" />
              </IonRow>
              <IonCardHeader>
                <IonCardTitle>Maintenance Intelligence</IonCardTitle>
              </IonCardHeader>

              <IonCardContent>
                Real-time tracking of aircraft component life, automatic
                generation of component lists, and predictive maintenance
                forecasts.
              </IonCardContent>
            </IonCard>
          </IonCol>
          <IonCol sizeMd="4" sizeXs="12">
            <IonCard className="show-card">
              <IonRow className="ion-justify-content-center">
                <IonImg src="clock-8.svg" />
              </IonRow>
              <IonCardHeader>
                <IonCardTitle>Weight and Balance</IonCardTitle>
              </IonCardHeader>

              <IonCardContent>
                Easily track starts, landings, and aircraft hours. Data is
                securely saved to the cloud and accessible anytime, anywhere.
              </IonCardContent>
            </IonCard>
          </IonCol>
          <IonCol sizeMd="4" sizeXs="12">
            <IonCard className="show-card">
              <IonRow className="ion-justify-content-center">
                <IonImg src="trending-up.svg" />
              </IonRow>
              <IonCardHeader>
                <IonCardTitle>Engine Trending</IonCardTitle>
              </IonCardHeader>

              <IonCardContent>
                Simplify engine ground performance runs. Automate reference
                value lookups and securely store parameter trends in the cloud.
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      </IonCol>
    </IonRow>
  );
}

export { EverythingYouNeed };
